import request from '@/services/interceptor.js'

export const get_tipiScadenzaMezzo = () => {
    return request({
        url: '/tiposcadenzamezzo',
        method: 'get',
        loadingBar: true
    })
}

export const get_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_tipoScadenzaMezzo = (par) => {
    return request({
        url: '/tiposcadenzamezzo',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_tipoScadenzaMezzo = (id, par) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

// Anteprima (nessuna scrittura): quante scadenze già pianificate cambierebbero data
// se la frequenza del tipo diventasse quella indicata.
export const get_impatto_frequenza_tipoScadenzaMezzo = (id, frequenzaValore, frequenzaUnita) => {
    return request({
        url: `/tiposcadenzamezzo/${id}/impatto-frequenza`,
        method: 'get',
        params: { frequenzaValore, frequenzaUnita },
        loadingBar: true
    })
}

export const duplica_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
